import Vue from 'vue'
import TransitionExpand from '@components/TransitionExpand.vue'

const els = document.querySelectorAll("[id^='subnav-item-app--']")
if (els != null) {
  els.forEach((el) => {
    var vm = new Vue({
      components: {
        TransitionExpand
      },
      data: () => {
        return {
          isActive: false
        }
      },
      delimiters: ['[[', ']]'],
      methods: {
        toggleActive () {
          this.isActive = !this.isActive
        },
        show () {
          this.isActive = true
        }
      },
      mounted () {
        if (el.classList.contains('is-active')) {
          this.isActive = true
        }
      }
    })
    vm.$mount(el)
  })
}

const jumpMenu = document.getElementById('jump-menu')
if (jumpMenu !== null) {
  jumpMenu.addEventListener('change', function () {
    location.replace(this.value)
  })
}
